export default __webpack_public_path__ + "static/media/ic-moneyback.ed079bde.svg";